import { VisibilityElement } from './visibility'

/**
 * List Display CUSTOM ELEMENT
 *
 * Used to render a element based of the selected value in a Select element
 *
 * Extending off the Visibility Element i have included a
 * global [data-visibility-open] on elements to trigger the modal.
 *
 * This was mostly because i was running into a z-index issue with the header.
 */

export class ListDisplayElement extends VisibilityElement {
  externalTrigger!: HTMLElement | null
  closeKeys!: NodeListOf<Element> | null
  selectTrigger!: Element | null

  static SELECT_KEY = '[data-role="list-trigger"]'
  static DISPLAY_OPTIONS_KEY = '[data-role="list-display-item"]'
  static CLOSE_KEY = '[data-role="close"]'

  handleSwitchUpdate = (key: string) => {
    this.dataset.switch = key
  }

  handleClose = () => {
    this.handleHide()
  }

  handleExternalOpen = () => {
    this.handleShow()
  }

  /**
   *
   * Toggles class based on if the class exists and the given boolean (condition)
   * value is true.
   *
   * @param {*} element
   * @param {*} className
   * @param {*} condition
   * @returns
   */
  handleView(element: Element, className: string, condition: boolean) {
    const classList = element.classList
    if (classList.contains(className) && condition) {
      classList.remove(className)
      return
    }
    classList.add(className)
  }

  handleListDisplay(e: Event) {
    const select = e.currentTarget as HTMLSelectElement
    this.querySelectorAll(ListDisplayElement.DISPLAY_OPTIONS_KEY).forEach((el) => {
      const element = el as HTMLElement
      const isSelected = select.value === element.dataset.opt
      this.handleView(el, 'hidden', isSelected)
    })
  }

  fetchChildren() {
    this.externalTrigger = document.querySelector(`[data-visibility-open="${this.dataset.id}"]`)
    this.closeKeys = this.querySelectorAll(ListDisplayElement.CLOSE_KEY)
    this.selectTrigger = this.querySelector(ListDisplayElement.SELECT_KEY)
  }

  addEventListeners() {
    this.externalTrigger?.addEventListener('click', this.handleExternalOpen.bind(this))
    this.closeKeys?.forEach((el) => {
      el.addEventListener('click', this.handleClose.bind(this))
    })
    this.selectTrigger?.addEventListener('change', this.handleListDisplay.bind(this))
  }

  removeEventListeners() {
    this.externalTrigger?.removeEventListener('click', this.handleExternalOpen.bind(this))

    this.closeKeys?.forEach((el) => {
      el.removeEventListener('click', this.handleClose.bind(this))
    })
    this.selectTrigger?.removeEventListener(
      'change',
      this.handleListDisplay.bind(this)
    )
  }

  connectedCallback() {
    super.connectedCallback()
    this.fetchChildren()
    this.addEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }
}
